enum TypeOfImport {
	SelectFile,
	SelectFolder,
	SelectCameraCard,
	DragNDrop,
}

export default TypeOfImport;
